import {
  generateInstallId
} from "./chunk-Q4L35BTE.mjs";
import {
  isValidInstallId
} from "./chunk-BVU3DLDU.mjs";
import {
  INSTALLATION_ID_KEY,
  defaultAllowExternalInstallId
} from "./chunk-ADSPBXJF.mjs";

// src/utils/context/get-install-id/get-install-id.ts
import Cookies from "js-cookie";
async function getInstallId() {
  if (window.yvaDatastore) {
    let setLocalStorage2 = function() {
      localStorage.setItem(INSTALLATION_ID_KEY, installId);
    }, setCookie2 = function() {
      if (window.yvaDatastore) {
        Cookies.set(INSTALLATION_ID_KEY, installId, { domain: window.yvaDatastore.config.baseDomain });
      }
    };
    var setLocalStorage = setLocalStorage2, setCookie = setCookie2;
    const installIdFromStorage = localStorage.getItem(INSTALLATION_ID_KEY);
    const installIdFromCookies = Cookies.get(INSTALLATION_ID_KEY);
    const params = new URLSearchParams(window.location.search);
    const installIdFromUrl = params.get(INSTALLATION_ID_KEY);
    let installId = "";
    if (installIdFromUrl && !installIdFromCookies && !installIdFromStorage && isValidInstallId(installIdFromUrl)) {
      installId = installIdFromUrl;
      setCookie2();
      setLocalStorage2();
    } else if (installIdFromUrl && (typeof window.yvaDatastore.config.allowExternalInstallId === "boolean" ? window.yvaDatastore.config.allowExternalInstallId : defaultAllowExternalInstallId) && isValidInstallId(installIdFromUrl)) {
      installId = installIdFromUrl;
      setCookie2();
      setLocalStorage2();
    } else if (installIdFromCookies && installIdFromStorage && (isValidInstallId(installIdFromCookies) || isValidInstallId(installIdFromStorage))) {
      if (installIdFromCookies === installIdFromStorage) {
        installId = installIdFromCookies;
      } else if (isValidInstallId(installIdFromCookies)) {
        installId = installIdFromCookies;
        setLocalStorage2();
      } else if (isValidInstallId(installIdFromStorage)) {
        installId = installIdFromStorage;
        setCookie2();
      }
    } else if (installIdFromCookies && !installIdFromStorage && isValidInstallId(installIdFromCookies)) {
      installId = installIdFromCookies;
      setLocalStorage2();
    } else if (installIdFromStorage && !installIdFromCookies && isValidInstallId(installIdFromStorage)) {
      installId = installIdFromStorage;
      setCookie2();
    } else {
      try {
        if (window.yvaDatastore.config.providers?.installIdProvider) {
          const installIdFromProvider = await window.yvaDatastore.config.providers.installIdProvider();
          if (installIdFromProvider && isValidInstallId(installIdFromProvider)) {
            installId = installIdFromProvider;
          } else {
            installId = generateInstallId();
          }
        } else {
          installId = generateInstallId();
        }
        setCookie2();
        setLocalStorage2();
      } catch (error) {
        if (window.yvaDatastore.config.debug) {
          console.error("Error setting installation id, falling back to generated id");
          console.dir(error, { depth: null });
        }
        installId = generateInstallId();
        setCookie2();
        setLocalStorage2();
      }
    }
    return installId;
  }
  return generateInstallId();
}

export {
  getInstallId
};
